
  import { Component, Vue }                       from 'vue-property-decorator';

  @Component({
    name: 'ScreenReaderOnlyNavBarComponent'
  })
  export default class ScreenReaderOnlyNavBarComponent extends Vue {
    focusInput(): void {
      // Put focus on input field
      const input = document.getElementById('chatbox-app-typer');
      input?.focus();
    }

    focusBotResponse(): void {
      const responseContainer = document.getElementById('str-msg-bot-content');
      if(responseContainer) {
        // Add tabIndex to be able to focus on non focussable element
        responseContainer.setAttribute('tabindex', '-1');
        responseContainer.focus();
        // Remove tabIndex to avoid changing keyboard navigation
        responseContainer.removeAttribute('tabindex');
      }
    }
  }
